import { Components, Theme } from '@mui/material/styles'
import { THEME_TRANSITION_CLASS } from './themeTransition'

const themeChangeTransition = (theme: Theme) =>
  theme.transitions.create(['background-color', 'color', 'border-color', 'fill', 'stroke', 'box-shadow'], {
    duration: theme.transitions.duration.shorter,
  })

export const cssBaselineTheme: Components<Theme>['MuiCssBaseline'] = {
  styleOverrides: {
    body: ({ theme }) => ({
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.background.default,
    }),
    '#root': {
      color: 'inherit',
    },
    [`html.${THEME_TRANSITION_CLASS}, html.${THEME_TRANSITION_CLASS} *`]: ({ theme }) => ({
      transition: `${themeChangeTransition(theme)} !important`,
    }),
  },
}
